import {Injectable} from '@angular/core';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {StickerDeleteCommand} from './sticker.delete.command';
import {StickerCreateCommand} from './sticker.create.command';
import {StickersService} from '../../diagram-interaction/services/stickers.service';
import {StickerChangeStyleCommand} from './sticker.changestyle.command';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';

@Injectable()
export class StickerCommands {
  private serviceObj: object;

  constructor(
    diagramUpdateSvc: DiagramUpdateService,
    shapeSpawnerSvc: ShapeSpawnerService,
    editorRegistrySvc: EditorRegistryService,
    graphHelperSvc: GraphHelperService,
    stickersSvc: StickersService,
    jsonHandlerSvc: DiagramJsonHandlerService
  ) {
    this.serviceObj = {
      diagramUpdateSvc,
      shapeSpawnerSvc,
      editorRegistrySvc,
      graphHelperSvc,
      stickersSvc,
      jsonHandlerSvc
    };
  }

  public create(data) {
    return new StickerCreateCommand(data).injectServices(this.serviceObj);
  }

  public changeStyle(mxKey: number, style: any) {
    return new StickerChangeStyleCommand({mxKey, style})
      .injectServices(this.serviceObj)
      .prepareData();
  }

  public delete(data) {
    return new StickerDeleteCommand(data).injectServices(this.serviceObj);
  }
}
